// extracted by mini-css-extract-plugin
module.exports = {"row":"_1geY8dCXyrpB9KIlNA4tLQ"};